import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { AIR_URL, BASE_URL } from './constant/BaseApiUrl';

export default class AirService {
  getAir() {
    return axios.get(`${AIR_URL}${ApiKey.AIR_PORTS}`);
  }
  getFlightInformation(payload) {
    return axios.post(`${AIR_URL}${ApiKey.FLIGHT_INFORMATION}`, payload);
  }
  generateQuoteId() {
    return axios.get(`${BASE_URL}${ApiKey.GENERATE_QUOTE_ID}`);
  }
  getListAirportCode() {
    return axios.get(`${AIR_URL}${ApiKey.AIRPORT_CODE}`);
  }
  searchFlightOptionJaw(payload: any) {
    return axios.post(`${AIR_URL}${ApiKey.FLIGHT_INFORMATION_JAW}`, payload);
  }
  searchFlightOptionOneWay(payload: any) {
    return axios.post(`${AIR_URL}${ApiKey.FLIGHT_INFORMATION_ONEWAY}`, payload);
  }
}
